import React from 'react';
import { Section } from './ui/Section';
import { BookOpenIcon, CalendarIcon, ClockIcon, FileTextIcon, HelpCircleIcon } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: BookOpenIcon,
    text: 'The full Sleep & Serenity ebook (step-by-step)'
  }, {
    icon: CalendarIcon,
    text: 'The 7-Day Implementation Plan'
  }, {
    icon: ClockIcon,
    text: 'The 2–4am Wake-Up Protocol'
  }, {
    icon: FileTextIcon,
    text: 'Printables: Evening Reset Checklist + Script Cards + Journaling Prompts'
  }, {
    icon: HelpCircleIcon,
    text: "FAQ + troubleshooting so you don't quit after a rough night"
  }];
  return <Section className="bg-cream-50" dark={false} data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <h2 className="text-3xl md:text-4xl font-serif text-navy-900 mb-12 text-center" data-id="element-128">
          What you'll get{' '}
          <span className="italic text-navy-600" data-id="element-129">(what's inside)</span>
        </h2>

        <div className="bg-white rounded-3xl shadow-xl border border-cream-200 overflow-hidden" data-id="element-130">
          <div className="divide-y divide-cream-100" data-id="element-131">
            {items.map((item, index) => <div key={index} className="p-6 md:p-8 flex items-start gap-6 hover:bg-cream-50/50 transition-colors" data-id="element-132">
                <div className="flex-shrink-0 w-12 h-12 bg-navy-50 rounded-full flex items-center justify-center text-navy-900" data-id="element-133">
                  <item.icon className="w-6 h-6" data-id="element-134" />
                </div>
                <div className="flex items-center h-12" data-id="element-135">
                  <p className="text-lg text-navy-800 font-medium" data-id="element-136">
                    {item.text}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}